import React from 'react'
import { Bookmark } from '../common/BookMarkIcons/Bookmark'
import { Bookmark3 } from '../../icons/Bookmarks3'
import { getTodaysStartHour, sendAnalyticsToGA, updateQueryParams } from '../../utils/commanFunctions';
import { useNavigate } from 'react-router';
import HeartIcon from '../../icons/HeartIcon';
import ImageComponent from './ImageComponent';
import DefaultSubComponet from '../common/SingleCardSubComponets/DefaultSubComponet';
import { trackWidgetClick } from '../../utils/FunctionsForGa';

const FavoritesGrid = ({
   placeName,
   placeType,
   images={},
   data={},
   groupData={},
   handleClick
  }) => {

  // timings = data.opening_hours
  //     ? getTodaysStartHour(data.opening_hours)
  //     : "";
const selectedFilter = JSON.parse(localStorage.getItem("selectedFilter"))
  const navigate = useNavigate();
   const handleGA = ()=>{
    if(process.env.REACT_APP_GA_ENABLED==="true"){
      const ga_payload = {
        action: selectedFilter,
        type: data?.type,
        widget_name:data?.name,
        isFavorite: isBookmarked(),
      }
  
      trackWidgetClick(ga_payload)
    }
   }



  const handleRedirect = (e) => {
      // const path = `/?path=description&ID=${data.id}`

      const currentPath = window.location.href;
  if (currentPath.includes("path=personalizedStayPage")) {
    sessionStorage.setItem("fromPersonalized", "true");
  }
      const path = updateQueryParams({
        path: "description",
        ID: data.id,
      });
      navigate(path);
    };

    const isBookmarked = () => {
  const bookMData = JSON.parse(localStorage.getItem("tripBookmarked")) || { ids: [] };
  return bookMData.ids.includes(data.id);
};

  return (
    <div className="favorites-full-card cursor-pointer "
    onClick={(e) => {
      e.stopPropagation();
      handleGA()
      if (handleClick) handleClick(data);
      else handleRedirect();
    }}
    >
    <div className="favorites-grid favorite-grid-1 grid grid-cols-2 gap-[6px] h-[177.5px] rounded-xl overflow-hidden mb-1">
        <ImageComponent imageUrl={images?.[0]?.image || 'https://placehold.co/600x400'} focalPoint={images?.[0]?.image_metadata?.focus_point}  passedClasses={'favorites-grid-left flex items-end p-2 object-cover'} >
            { placeType && <div className='py-[2px] px-2 text-[#f8f8f8] text-xs rounded-lg backdrop-blur-sm backdrop-brightness-50'>{placeType}</div>}
        </ImageComponent>
        <div className="favorites-grid-right grid grid-rows-2 gap-[6px] h-full w-full">
          
          <ImageComponent imageUrl={images?.[1]?.image || 'https://placehold.co/600x400'} focalPoint={images?.[1]?.image_metadata?.focus_point} passedClasses='favorites-grid-right-top flex justify-end p-2'>
            <div className='pr-[2px] px-2 text-[#f8f8f8] h-fit rounded-full'>

                <Bookmark
                            className={
                               `!p-1.5 icon-on-card  rounded-md bg-[#00000080] cursor-pointer`
                            }
                            icon={<HeartIcon className="!relative !w-4 !h-4 bookmark-icon" />}
                            stateProp="default"
                            id={data.id}
                            name={data.name}
                            isBookmarked={isBookmarked}
                          />

            </div>
          </ImageComponent>
          <ImageComponent imageUrl={images?.[2]?.image || 'https://placehold.co/600x400'} focalPoint={images?.[2]?.image_metadata?.focus_point} passedClasses={'favorites-grid-right-bottom'} />
          {/* <div style={{backgroundImage: `url(${images?.[2]?.image || 'https://placehold.co/600x400'})`}}  className="favorites-grid-right-bottom h-full w-full  bg-cover bg-center"></div> */}
        </div>
      </div>
      <p className='text-[16px] text-[#1A1A1A]' >{placeName}</p>
      {/* <div className='flex gap-1 items-center text-[14px] text-[#4d4d4d]'>
      <svg class="!relative !w-4 !h-4" fill="none" height="17" viewBox="0 0 16 17" width="16" xmlns="http://www.w3.org/2000/svg">
      <path d="M8.43035 1.68378C8.15811 1.55398 7.84184 1.55398 7.5696 1.68378C7.33426 1.79599 7.2045 1.99081 7.13906 2.09769C7.07142 2.20818 7.00197 2.34894 6.93429 2.48613L5.49713 5.39765L2.28243 5.86753C2.13111 5.88961 1.97583 5.91228 1.84989 5.94256C1.72805 5.97186 1.50278 6.03523 1.3235 6.22445C1.11611 6.44337 1.01857 6.74418 1.05805 7.04313C1.09218 7.30155 1.23741 7.48505 1.31888 7.58027C1.40309 7.6787 1.51552 7.78817 1.6251 7.89485L3.95029 10.1596L3.40165 13.3584C3.37575 13.5093 3.34918 13.664 3.33895 13.7932C3.32906 13.9181 3.3195 14.1521 3.44396 14.3812C3.58793 14.6463 3.84385 14.8322 4.14043 14.8871C4.39684 14.9347 4.61636 14.8533 4.73211 14.8052C4.85181 14.7556 4.99076 14.6825 5.1262 14.6112L7.99997 13.0999L10.8738 14.6112C11.0092 14.6825 11.1481 14.7556 11.2678 14.8052C11.3836 14.8533 11.6031 14.9347 11.8595 14.8871C12.1561 14.8322 12.412 14.6463 12.556 14.3812C12.6805 14.1521 12.6709 13.9181 12.661 13.7932C12.6508 13.664 12.6242 13.5093 12.5983 13.3585L12.0497 10.1596L14.3749 7.89482C14.4844 7.78815 14.5969 7.67869 14.6811 7.58027C14.7625 7.48505 14.9078 7.30155 14.9419 7.04313C14.9814 6.74418 14.8838 6.44337 14.6764 6.22445C14.4972 6.03523 14.2719 5.97186 14.1501 5.94256C14.0241 5.91228 13.8688 5.88961 13.7175 5.86753L10.5028 5.39765L9.06569 2.48618C8.998 2.34898 8.92854 2.20819 8.86089 2.09769C8.79545 1.99081 8.66569 1.79599 8.43035 1.68378Z" fill="#FFAA00"></path>
      </svg>
        <span>{rating}</span>
        {timings && <span>•{timings}</span>}
        {price && <span>•{price}</span>}
        </div> */}
        <DefaultSubComponet data={data}/>
      </div>
  )
}

export default FavoritesGrid